<div class="spinnerContainer" [class.overlay]="isOverlay()">
    <span class="loader"></span>
    @if (placeholder()) {
        <div class="spinnerText">{{ placeholder() }}</div>
    }
</div>
